import { ModalOverlay as ChakraModalOverlay } from "@chakra-ui/react";

export const ModalOverlay = ChakraModalOverlay;
